<form [formGroup]="schuldigerkenningFg">
    <snelstart-ui-text-form-control formControlName="omschrijving"
                                    id="omschrijving"
                                    label="Omschrijving"
                                    class="me-1 custom-input-250"
                                    (change)="saveForm()"
    >
    </snelstart-ui-text-form-control>
    <snelstart-ui-number-form-control formControlName="bedrag"
                                      id="bedrag"
                                      label="Bedrag"
                                      [showAllDecimals]="false"
                                      align="right"
                                      prefix="€"
                                      [minValue]="1"
                                      class="me-1 custom-input-250"
                                      (change)="saveForm()"
    >
    </snelstart-ui-number-form-control>
    <snelstart-ui-number-form-control formControlName="rentePercentage"
                                      id="rentePercentage"
                                      label="Rentepercentage"
                                      [showAllDecimals]="true"
                                      align="right"
                                      postfix="%"
                                      class="me-1 custom-input-250"
                                      (change)="saveForm()"
    >
    </snelstart-ui-number-form-control>
    <snelstart-ui-select-form-control formControlName="enkelvoudigeRente"
                                      id="enkelvoudigeRente"
                                      label="Is dit een enkelvoudige rente?"
                                      class="me-1 custom-input-250"
                                      [required]=true
                                      [options]="this.optionsJaNee"
                                      (change)="saveForm()"
    >
    </snelstart-ui-select-form-control>
    <snelstart-ui-date-form-control formControlName="datumAkte"
                                    id="datumAkte"
                                    label="Datum schenkingsakte"
                                    class="me-1 custom-input-250"
                                    (change)="saveForm()"
    >
    </snelstart-ui-date-form-control>
    <snelstart-ui-date-form-control formControlName="datumOpeisbaar"
                                    id="datumOpeisbaar"
                                    label="Datum opeisbaarheid"
                                    class="me-1 custom-input-250"
                                    (change)="saveForm()"
    >
    </snelstart-ui-date-form-control>
</form>
